export { default } from './SameDayDepositInfoBox'
